"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_3.ts
const product_types_1 = require("../types/product.types");
const products = [
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 657,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-23-marc-09-14",
        title: "3a prova Mossos 2025 - 23 març 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 23 març 09:00 a 14:00 h",
        short: "7.) 3a prova Mossos 2025 - 23 març 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2132], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 658,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-23-marc-16-20",
        title: "3a prova Mossos 2025 - 23 març 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 23 març 15:00 a 20:00 h",
        short: "8.) 3a prova Mossos 2025 - 23 març 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2135], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 659,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-29-marc-09-14",
        title: "3a prova Mossos 2025 - 29 març 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 29 març 09:00 a 14:00 h",
        short: "9.) 3a prova Mossos 2025 - 29 març 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2138], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 660,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-29-marc-16-20",
        title: "3a prova Mossos 2025 - 29 març 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 29 març 15:00 a 20:00 h",
        short: "10.) 3a prova Mossos 2025 - 29 març 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2141], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // 661. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 661,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-30-marc-09-14",
        title: "3a prova Mossos 2025 - 30 març 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 30 març 09:00 a 14:00 h",
        short: "11.) 3a prova Mossos 2025 - 30 març 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2144], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 662,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-30-marc-16-20",
        title: "3a prova Mossos 2025 - 30 març 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 30 març 15:00 a 20:00 h",
        short: "12.) 3a prova Mossos 2025 - 30 març 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2147], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 663,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-5-abril-09-14",
        title: "3a prova Mossos 2025 - 5 abril 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 5 abril 09:00 a 14:00 h",
        short: "13.) 3a prova Mossos 2025 - 5 abril 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2150], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 664,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-5-abril-16-20",
        title: "3a prova Mossos 2025 - 5 abril 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 5 abril 15:00 a 20:00 h",
        short: "14.) 3a prova Mossos 2025 - 5 abril 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2153], limit: 45 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 665,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-2025-6-abril-09-14",
        title: "3a prova Mossos 2025 - 6 abril 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 6 abril 09:00 a 14:00 h",
        short: "15.) 3a prova Mossos 2025 - 6 abril 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2156], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 666,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-2025-6-abril-16-20",
        title: "3a prova Mossos 2025 - 6 abril 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 6 abril 15:00 a 20:00 h",
        short: "16.) 3a prova Mossos 2025 - 6 abril 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2159], limit: 40 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 680,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-2025-13-abril-09-14",
        title: "3a prova Mossos 2025 - 13 abril 9:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 13 abril 9:00 a 14:00 h",
        short: "17.) 3a prova Mossos 2025 - 13 abril 9 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2184], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 686,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-2025-13-abril-15-20",
        title: "3a prova Mossos 2025 - 13 abril 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 13 abril 15:00 a 20:00 h",
        short: "18.) 3a prova Mossos 2025 - 13 abril 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2199], limit: 40 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 699,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-2025-12-abril-09-14",
        title: "3a prova Mossos 2025 - 12 abril 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 12 abril 09:00 a 14:00 h",
        short: "19.) 3a prova Mossos 2025 - 12 abril 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-04-01 00:00:10",
        start_at: "2025-04-01 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2220], limit: 40 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 700,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-2025-12-abril-15-20",
        title: "3a prova Mossos 2025 - 12 abril 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 12 abril 15:00 a 20:00 h",
        short: "20.) 3a prova Mossos 2025 - 12 abril 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-04-01 00:00:10",
        start_at: "2025-04-01 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2223], limit: 40 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Simulacre Presencial Pre-Oficial Mossos d'Esquadra 2025
    {
        id: 667,
        tax: 0.0,
        hidden: true,
        sku: "iopos.course.f2f.simulacre-pre-oficial-mossos-14-febrer-2025",
        title: "Simulacre Pre-Oficial Mossos d'Esquadra 2025 (14 febrer)",
        name: "Simulacre Pre-Oficial Mossos d'Esquadra 2025 (14 febrer)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos, product_types_1.Category.Psicos],
        description: "L'última empenta abans del gran dia! Hem preparat un simulacre presencial de temari i psicotècnics de MOLT NIVELL perquè posis a prova els teus coneixements i repassis conceptes clau.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 39.99,
        shipment: 0.0,
        images: ["/667/image1"],
        banner: ["/667/image1"],
        created_at: "2025-01-22 00:00:10",
        start_at: "2025-01-22 00:00:10",
        link: "/tienda/cursos/simulacre-pre-oficial-mossos-desquadra-14-febrer-2025/",
        more_info: true,
        limit: 60,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        notify_emails: ["txema@iopos.academy"],
    },
    // Tarifa Plana Físiques Sant Adrià del Besós Març 2025
    {
        id: 668,
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.proves-fisiques-sant-adria-marc-2025-tarifaplana",
        title: "Tarifa plana físiques (Sant Adrià del Besós 2025)",
        name: "Tarifa plana físiques (Sant Adrià del Besós 2025)",
        description: "Entrena sense límits i prepara't per superar les teves físiques amb la TARIFA PLANA! 💪🔥",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        price: 89.99,
        //offer: 79.99,
        //recurrent: 'monthly',
        //offer_text: "¡Oferta curso primer mes!",
        shipment: 0.0,
        images: ["/668/image1"],
        banner: ["/668/image1"],
        link: "/tienda/cursos/tarifa-plana-fisiques-sant-adria-marc-2025/",
        created_at: "2025-01-29 00:00:02",
        start_at: "2025-01-29 00:00:02",
        teachers: [""],
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        disallow_multiple_units: true,
    },
    // Simulacre Físiques Sant Cugat 28 Desembre 2025
    {
        id: 670,
        category: [product_types_1.Category.Sports, product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.simulacre-fisiques-sant-cugat-28d-2025-16-18",
        title: "Simulacre de Físiques (CrossFit Lynx Sant Cugat, 28 Desembre 2025) (16-18 h)",
        name: "Simulacre de Físiques (CrossFit Lynx Sant Cugat, 28 Desembre 2025) (16-18 h)",
        description: "No deixis escapar l'oportunitat de preparar-te amb el nostre Simulacre de Físiques 2025 al CrossFit Lynx!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 24.99,
        shipment: 0.0,
        images: ["/670/image2"],
        banner: ["/670/image2"],
        link: "/tienda/cursos/simulacre-fisiques-sant-cugat-28-desembre-2025-16-18-h/",
        created_at: "2025-12-12 00:00:01",
        start_at: "2025-12-12 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 200,
        discount_not_applicable: true,
    },
    // Test Psicoprofessional Mossos d'Esquadra 2025
    {
        id: 671,
        hidden: true,
        category: [product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.test-psicoprofessional-mossos-2025",
        title: "Test Psicoprofessional Mossos d'Esquadra 2025",
        name: "Test Psicoprofessional Mossos d'Esquadra 2025",
        description: "",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        price: 39.99,
        shipment: 0.0,
        images: ["/671/image1"],
        banner: ["/671/image1"],
        link: "/tienda/cursos/test-psicoprofessional-mossos-2025/",
        created_at: "2025-03-03 00:00:02",
        start_at: "2025-03-03 00:00:02",
        more_info: true,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
    },
    // Curs Presencial 4/2015 i Codi Penal 2025 - 6 Abril
    {
        id: 672,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.ISPC],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-4-2015-codi-penal-2025-diumenge-6-abril",
        title: "Curs Presencial 4/2015 i Codi Penal (06/04/25 - 9 a 14 i 15 a 18)",
        name: "Curs Presencial 4/2015 i Codi Penal (06/04/25 - 9 a 14 i 15 a 18)",
        description: "Domina la Llei de Seguretat Ciutadana i el Codi Penal amb un curs pràctic i essencial per a opositors. Aprèn a aplicar la normativa amb seguretat i confiança. Reserva la teva plaça ara!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 59.99,
        shipment: 0.0,
        images: ["/672/image2"],
        banner: ["/672/image2"],
        link: "/tienda/cursos/curs-presencial-4-2015-codi-penal-6-abril-2025/",
        created_at: "2025-03-05 00:00:02",
        start_at: "2025-03-05 00:00:02",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 411, group_id: [2180] },
    },
    // Curs Presencial Guàrdia Urbana Barcelona 2025 (80 hores)
    {
        id: 673,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.GUB],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-open-bcn-curs-gub-2025-80h",
        title: "Curs Presencial Guàrdia Urbana Barcelona 2025 (80 hores)",
        name: "Curs Presencial Guàrdia Urbana Barcelona 2025 (80 hores)",
        description: "Prepara't amb el mètode que ha ajudat al 79% dels aspirants aptes a superar les proves de la Guàrdia Urbana de Barcelona!",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 499.99,
        // offer: 499.99,
        // offer_message: "Aprofita el 15% de descompte!",
        shipment: 0.0,
        images: ["/673/image5"],
        banner: ["/673/image5"],
        link: "/tienda/cursos/curs-presencial-guardia-urbana-barcelona-2025-80-hores/",
        created_at: "2025-04-22 00:00:01",
        start_at: "2025-04-22 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        childs: [674],
    },
    // Curs Presencial Guàrdia Urbana Barcelona 2025 - Dissabtes de 08:00 a 15:00 h
    {
        id: 674,
        tax: 0.0,
        sku: "iopos.course.f2f.2025-open-bcn-curs-gub-2025-80h-dis-8-15",
        title: "Curs Presencial GUB 2025 - Dissabtes de 08:00 a 15:00 h",
        name: "Curs Presencial GUB 2025 - Dissabtes de 08:00 a 15:00 h",
        short: "1.) GUB 2025 - Dissabtes 8 a 15 h",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.GUB],
        description: "Prepara't amb el mètode que ha ajudat al 79% dels aspirants aptes a superar les proves de la Guàrdia Urbana de Barcelona!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 499.99,
        // offer: 499.99,
        // offer_message: "Aprofita el 15% de descompte!",
        shipment: 0.0,
        images: ["/673/image2"],
        created_at: "2025-03-13 00:00:10",
        start_at: "2025-03-13 00:00:10",
        more_info: false,
        evolmind: { course_id: 313, group_id: [2183], limit: 30 },
        can_be_sent: false,
        items: 1,
        default_in_parent: true,
        parent: 673,
    },
    // Curs Online Preparació Tercera Prova Mossos d'Esquadra 2025
    {
        id: 678,
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.Online,
            product_types_1.Category.Mossos,
            product_types_1.Category.FASE1,
        ],
        tax: 0.21,
        sku: "iopos.course.online.3a-prova-mossos-2025",
        title: "Preparació Online 3a Prova Mossos 2025",
        name: "Preparació Online 3a Prova Mossos 2025",
        description: "Domina la fase psicoprofessional de l'oposició amb un curs intensiu de 5 hores en directe! 🚀 Aprèn dels millors, prepara't amb material exclusiu i assegura el teu èxit!",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 69.99,
        shipment: 0.0,
        images: ["/678/image1"],
        banner: ["/678/image1"],
        link: "/tienda/cursos/preparacio-online-3a-prova-mossos-2025/",
        created_at: "2025-04-21 00:00:01",
        start_at: "2025-04-21 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 289, group_id: [2187] },
    },
    // Pla Tutoritzat Mossos d'Esquadra 2025
    {
        id: 679,
        tax: 0.21,
        sku: "iopos.course.online.pla-tutoritzat-mossos-desquadra",
        title: "Pla Tutoritzat Mossos d'Esquadra",
        name: "Pla Tutoritzat Mossos d'Esquadra",
        category: [
            /*Category.Online, Category.Mossos, Category.FaceToFace,*/ product_types_1.Category.PLANES,
        ],
        description: "El camí més ràpid per ser Mosso/a! 🔥 Formació total, tutor exclusiu i un grup reduït amb el mateix objectiu: aprovar en temps rècord.",
        enabled: false,
        stock: false,
        stock_message: "Temporalment sense estoc!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 1899.99,
        split_payment: "Divideix el pagament en 3 còmodes quotes de 633,33 €!",
        shipment: 0.0,
        images: ["/679/image2"],
        banner: ["/679/image2"],
        link: "/tienda/cursos/pla-tutoritzat-mossos-desquadra/",
        created_at: "2025-12-31 00:00:12",
        start_at: "2025-12-31 00:00:12",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial Espai Bulevard Mollet 2025 - Sessions
    {
        id: 681,
        tax: 0.0,
        sku: "iopos.course.f2f.espai-bulevard-mollet-2025",
        title: "Espai Bulevard 2025 - Mollet",
        name: "Espai Bulevard 2025 - Mollet",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        description: "🔥 Domina cada intervenció abans de trepitjar el carrer. Entrena en entorns realistes i prepara't per destacar a l'escola de policia. 🚀",
        enabled: false,
        stock: false,
        stock_message: "No disponible temporalment.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        images: ["/681/image3"],
        created_at: "2025-03-20 00:00:10",
        start_at: "2025-03-20 00:00:10",
        more_info: true,
        link: "/tienda/cursos/espai-bulevard-mollet-2025/",
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        childs: [682, 695, 683],
    },
    // Curs Presencial Espai Bulevard Mollet 2025 - Sessions
    {
        id: 682,
        tax: 0.0,
        sku: "iopos.course.f2f.espai-bulevard-mollet-2025-26_04_25_10_15",
        title: "Espai Bulevard 2025 - Mollet: 26/04/25 de 10 - 15 h",
        name: "Espai Bulevard 2025 - Mollet: 26/04/25 de 10 - 15 h",
        short: "1) Espai Bulevard Mollet - Dissabte 26/04/25 de 10 a 15 h",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        description: "🔥 Domina cada intervenció abans de trepitjar el carrer. Entrena en entorns realistes i prepara't per destacar a l'escola de policia. 🚀",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        images: ["/681/image3"],
        created_at: "2025-04-26 00:00:10",
        start_at: "2025-04-26 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        evolmind: { course_id: 525, group_id: [2190] },
        parent: 681,
        default_in_parent: true,
    },
    // Curs Presencial Espai Bulevard Mollet 2025 - Sessions
    {
        id: 683,
        tax: 0.0,
        sku: "iopos.course.f2f.espai-bulevard-mollet-2025-27_04_25_10_15",
        title: "Espai Bulevard 2025 - Mollet: 27/04/25 de 10 - 15 h",
        name: "Espai Bulevard 2025 - Mollet: 27/04/25 de 10 - 15 h",
        short: "2) Espai Bulevard Mollet - Diumenge 27/04/25 de 10 a 15 h",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        description: "🔥 Domina cada intervenció abans de trepitjar el carrer. Entrena en entorns realistes i prepara't per destacar a l'escola de policia. 🚀",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        images: ["/681/image3"],
        created_at: "2025-03-24 00:00:10",
        start_at: "2025-03-24 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 681,
        evolmind: { course_id: 525, group_id: [2190] },
    },
    // Curs Presencial Espai Bulevard Mollet 2025 - Sessions
    {
        id: 695,
        tax: 0.0,
        sku: "iopos.course.f2f.espai-bulevard-mollet-2025-27_04_25_16_21",
        title: "Espai Bulevard 2025 - Mollet: 27/04/25 de 16 - 21 h",
        name: "Espai Bulevard 2025 - Mollet: 27/04/25 de 16 - 21 h",
        short: "3) Espai Bulevard Mollet - Diumenge 27/04/25 de 16 a 21 h",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        description: "🔥 Domina cada intervenció abans de trepitjar el carrer. Entrena en entorns realistes i prepara't per destacar a l'escola de policia. 🚀",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        images: ["/681/image3"],
        created_at: "2025-04-24 00:00:10",
        start_at: "2025-04-24 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 681,
        evolmind: { course_id: 525, group_id: [2190] },
    },
    // Curs Presencial Espai Bulevard Mollet 2025 - Sessions
    {
        id: 692,
        tax: 0.0,
        sku: "iopos.course.f2f.espai-bulevard-mollet-2025-12_04_25_10_15",
        title: "Espai Bulevard 2025 - Mollet: 12/04/25 de 10 - 15 h",
        name: "Espai Bulevard 2025 - Mollet: 12/04/25 de 10 - 15 h",
        short: "4) Espai Bulevard Mollet - Dissabte 12/04/25 de 10 a 15 h",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        description: "🔥 Domina cada intervenció abans de trepitjar el carrer. Entrena en entorns realistes i prepara't per destacar a l'escola de policia. 🚀",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        images: ["/681/image3"],
        created_at: "2025-03-24 00:00:10",
        start_at: "2025-03-24 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 681,
        evolmind: { course_id: 525, group_id: [2190] },
    },
    // Curs Presencial Espai Bulevard Mollet 2025 - Sessions
    {
        id: 693,
        tax: 0.0,
        sku: "iopos.course.f2f.espai-bulevard-mollet-2025-13_04_25_10_15",
        title: "Espai Bulevard 2025 - Mollet: 13/04/25 de 10 - 15 h",
        name: "Espai Bulevard 2025 - Mollet: 13/04/25 de 10 - 15 h",
        short: "5) Espai Bulevard Mollet - Diumenge 13/04/25 de 10 a 15 h",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        description: "🔥 Domina cada intervenció abans de trepitjar el carrer. Entrena en entorns realistes i prepara't per destacar a l'escola de policia. 🚀",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        images: ["/681/image3"],
        created_at: "2025-03-24 00:00:10",
        start_at: "2025-03-24 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 681,
        evolmind: { course_id: 525, group_id: [2190] },
    },
    // Curs Presencial Espai Bulevard Mollet 2025 - Sessions
    {
        id: 694,
        tax: 0.0,
        sku: "iopos.course.f2f.espai-bulevard-mollet-2025-13_04_25_16_21",
        title: "Espai Bulevard 2025 - Mollet: 13/04/25 de 16 - 21 h",
        name: "Espai Bulevard 2025 - Mollet: 13/04/25 de 16 - 21 h",
        short: "6) Espai Bulevard Mollet - Diumenge 13/04/25 de 16 a 21 h",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        description: "🔥 Domina cada intervenció abans de trepitjar el carrer. Entrena en entorns realistes i prepara't per destacar a l'escola de policia. 🚀",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        images: ["/681/image3"],
        created_at: "2025-03-24 00:00:10",
        start_at: "2025-03-24 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 681,
        evolmind: { course_id: 525, group_id: [2190] },
    },
    // Curs Presencial Intensiu per a la Policia Municipal de Terrassa 2025 (27 d'abril)
    {
        id: 684,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-terrassa-2025-27-abril",
        title: "Curs Presencial Intensiu per a la Policia Municipal de Terrassa 2025 (27 d'abril)",
        name: "Curs Presencial Intensiu per a la Policia Municipal de Terrassa 2025 (27 d'abril)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        description: "💥 Prepara't per destacar a l'examen amb l'intensiu més complet i actualitzat de Terrassa 2025!",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        images: ["/684/image1"],
        created_at: "2025-03-21 00:00:10",
        start_at: "2025-03-21 00:00:10",
        more_info: true,
        link: "/tienda/cursos/curs-presencial-intensiu-terrassa-2025-30-abril/",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 123, group_id: [2165] },
    },
    // Curso Online Policía Municipal Madrid 2025
    {
        id: 685,
        tax: 0.21,
        sku: "iopos.course.online.curso-policia-municipal-madrid-2026",
        title: "Curso Online Policía Municipal Madrid 2026",
        name: "Curso Online Policía Municipal Madrid 2026",
        category: [product_types_1.Category.Online, product_types_1.Category.PMM],
        description: "La preparación online más completa y actualizada para convertir tu esfuerzo en una plaza en la Policía Municipal de Madrid.",
        enabled: true,
        stock: false,
        stock_message: "Próximamente inscripciones",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 399.99,
        // offer_message: "¡Oferta las 100 primeras matrículas!",
        images: ["/685/image1"],
        created_at: "2025-12-19 00:00:01",
        start_at: "2025-12-19 00:00:01",
        more_info: true,
        link: "/tienda/cursos/curso-online-policia-municipal-madrid-2026/",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 540, group_id: [2196] },
        app: { modules: [126, 96, 83], duration: 6 },
    },
    // Curs Presencial Mossos d'Esquadra 2025 (30 hores)
    {
        id: 687,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-30-hores",
        title: "Curs Presencial Mossos d'Esquadra 2025 (30 hores)",
        name: "Curs Presencial Mossos d'Esquadra 2025 (30 hores)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "El curs més intensiu, pràctic i complet per superar amb èxit les proves de Mossos d'Esquadra.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 199.99,
        offer: 289.99,
        offer_text: "Aprofita el gran descompte!",
        shipment: 0.0,
        images: ["/687/image2"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-30-hores/",
        created_at: "2025-06-15 00:00:10",
        start_at: "2025-06-15 00:00:10",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        // childs: [919, 920],
    },
    // Curs Presencial Mossos d'Esquadra 2025 (30 hores - Diumenges)
    {
        id: 691,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-30-hores-dissabtes",
        title: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dissabtes Juliol/Agost)",
        name: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dissabtes Juliol/Agost)",
        short: "3) Grup 30 hores els Dissabtes (Juliol/Agost)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "El curs més intensiu, pràctic i complet per superar amb èxit les proves de Mossos d'Esquadra.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 289.99,
        // offer: 289.99,
        // offer_text: "Promoció Mossos 2025!",
        shipment: 0.0,
        images: ["/687/image2"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-30-hores-diumenges/",
        created_at: "2025-06-15 00:00:10",
        start_at: "2025-06-15 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2601], limit: 30 },
        parent: 687,
        default_in_parent: false,
    },
    // Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dissabtes Setembre/Octubre)
    {
        id: 690,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-presencial-mossos-2025-30-hores-dissabtes-setembre-octubre",
        title: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dissabtes Setembre/Octubre)",
        name: "Curs Presencial Mossos d'Esquadra 2025 (30 hores - Dissabtes Setembre/Octubre)",
        short: "4) Grup 30 hores els Dissabtes (Setembre/Octubre)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "El curs més intensiu, pràctic i complet per superar amb èxit les proves de Mossos d'Esquadra.",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 289.99,
        // offer: 289.99,
        // offer_text: "Promoció Mossos 2025!",
        shipment: 0.0,
        images: ["/687/image2"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-30-hores/",
        created_at: "2025-04-22 00:00:10",
        start_at: "2025-04-22 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2610], limit: 30 },
        parent: 687,
        default_in_parent: false,
    },
    // Preparació Entrevista Policial Online 2025 (1:30 h)
    {
        id: 688,
        tax: 0.21,
        sku: "iopos.course.online.prep-entrevista-policial-online-130-2025",
        title: "Preparació Entrevista Policial Online 2025 (1:30 h)",
        name: "Preparació Entrevista Policial Online 2025 (1:30 h)",
        description: "Destaquem el millor de tu per superar l'entrevista amb èxit.",
        enabled: true,
        stock: true,
        special_buy: "/tienda/cursos/preparacio-entrevista-policial-online-2025-130/#disponibles",
        stock_message: "No disponible.",
        category: [product_types_1.Category.Interviews, product_types_1.Category.Mossos, product_types_1.Category.FASE2],
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 129.99,
        shipment: 0.0,
        images: ["/688/image1"],
        banner: ["/688/image1"],
        link: "/tienda/cursos/preparacio-entrevista-policial-online-2025-130/",
        created_at: "2025-03-24 00:00:01",
        start_at: "2025-03-24 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial 4/2015 i Codi Penal 2025 - 17 Maig
    {
        id: 689,
        category: [product_types_1.Category.FaceToFace],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.curs-4-2015-codi-penal-2025-dissabte-17-maig",
        title: "Curs Presencial 4/2015 i Codi Penal (17/05/25 - 9 a 14 i 15 a 18)",
        name: "Curs Presencial 4/2015 i Codi Penal (17/05/25 - 9 a 14 i 15 a 18)",
        description: "Domina la Llei de Seguretat Ciutadana i el Codi Penal amb un curs pràctic i essencial per a opositors. Aprèn a aplicar la normativa amb seguretat i confiança. Reserva la teva plaça ara!",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides",
        price: 59.99,
        shipment: 0.0,
        images: ["/689/image1"],
        banner: ["/689/image1"],
        link: "/tienda/cursos/curs-presencial-4-2015-codi-penal-17-maig-2025/",
        created_at: "2025-03-24 00:00:02",
        start_at: "2025-03-24 00:00:02",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 411, group_id: [2205], limit: 30 },
    },
    // MàsterClass Casos Pràctics Policia Municipal Sabadell 2025 (10 maig 8:30 - 13:30 h)
    {
        id: 696,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.online.2025-111-masterclass-casos-practics-sabadell-2025",
        title: "MàsterClass Casos Pràctics Policia Municipal Sabadell 2025 (10 maig 8:30 - 13:30 h)",
        name: "MàsterClass Casos Pràctics Policia Municipal Sabadell 2025 (10 maig 8:30 - 13:30 h)",
        description: "🔥 Domina la resolució de casos pràctics i apropa't a la teva plaça a la Policia Municipal de Sabadell!",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        price: 39.99,
        shipment: 0.0,
        images: ["/696/image1"],
        banner: ["/696/image1"],
        link: "/tienda/cursos/masterclass-casos-practics-policia-municipal-sabadell-2025/",
        created_at: "2025-03-24 00:00:01",
        start_at: "2025-03-24 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 430, group_id: [2214] },
    },
    // Tutorització Presencial Policies Locals Catalunya 2025
    {
        id: 676,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-policies-locals-2025",
        title: "Tutorització Presencial Policies Locals Catalunya 2025",
        name: "Tutorització Presencial Policies Locals Catalunya 2025",
        description: "Posa't a prova com mai abans! Un entrenament intensiu i personalitzat de 6 hores per superar totes les fases de l'oposició a policies locals.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta especial les primeres 20 matrícules!",
        shipment: 0.0,
        images: ["/676/image5"],
        banner: ["/676/image5"],
        link: "/tienda/cursos/tutoritzacio-policies-locals-catalunya-2025/",
        created_at: "2025-04-23 00:00:01",
        start_at: "2025-04-23 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        childs: [697, 698, 712, 815],
    },
    // Tutorització Presencial Policies Locals Catalunya 2025 (11 Maig - Sessió 3)
    {
        id: 697,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-pl-2025-11-maig-repeticio-sessio-3",
        title: "Tutorització Presencial Policies Locals Catalunya 2025 (11 Maig - Sessió 3)",
        name: "Tutorització Presencial Policies Locals Catalunya 2025 (11 Maig - Sessió 3)",
        short: "2) Tutorització Diumenge 11 Maig (Sessió 3)",
        description: "Posa't a prova com mai abans! Un entrenament intensiu i personalitzat de 6 hores per superar totes les fases de l'oposició a policies locals.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta especial les primeres 20 matrícules!",
        shipment: 0.0,
        images: ["/676/image5"],
        banner: ["/676/image5"],
        link: "/tienda/cursos/tutoritzacio-policies-locals-catalunya-2025/",
        created_at: "2025-04-23 00:00:01",
        start_at: "2025-04-23 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 676,
        default_in_parent: false,
    },
    // Tutorització Presencial Policies Locals Catalunya 2025 (1 Juny - Sessió 4)
    {
        id: 698,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-pl-2025-1-juny-sessio-4",
        title: "Tutorització Presencial Policies Locals Catalunya 2025 (1 Juny - Sessió 4)",
        name: "Tutorització Presencial Policies Locals Catalunya 2025 (1 Juny - Sessió 4)",
        short: "3) Tutorització Diumenge 1 Juny (Sessió 4)",
        description: "Posa't a prova com mai abans! Un entrenament intensiu i personalitzat de 6 hores per superar totes les fases de l'oposició a policies locals.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta especial les primeres 20 matrícules!",
        shipment: 0.0,
        images: ["/676/image5"],
        banner: ["/676/image5"],
        link: "/tienda/cursos/tutoritzacio-policies-locals-catalunya-2025/",
        created_at: "2025-04-23 00:00:00",
        start_at: "2025-04-23 00:00:00",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 676,
        default_in_parent: true,
    },
    // Tutorització Presencial Policies Locals Catalunya 2025 (4 Maig - RolePlay Grupal)
    {
        id: 712,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-pl-roleplay-grupal-4-maig",
        title: "RolePlay Grupal 2025 (4 Maig)",
        name: "RolePlay Grupal 2025 (4 Maig)",
        short: "4) RolePlay Grupal (Diumenge 4 maig)",
        description: "Posa't a prova com mai abans! Un entrenament intensiu i personalitzat de 6 hores per superar totes les fases de l'oposició a policies locals.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta especial les primeres 20 matrícules!",
        shipment: 0.0,
        images: ["/676/image5"],
        banner: ["/676/image5"],
        link: "/tienda/cursos/tutoritzacio-policies-locals-catalunya-2025/",
        created_at: "2025-04-23 00:00:00",
        start_at: "2025-04-23 00:00:00",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 676,
        default_in_parent: false,
    },
    // Curs Online per Policia Local de Sant Boi 2025
    {
        id: 701,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.online.2025-open-sbl-curs-online-santboi-2025",
        title: "Curs Online per Policia Local de Sant Boi 2025",
        name: "Curs Online per Policia Local de Sant Boi 2025",
        description: "No només estudies, avances: materials actualitzats, vídeo-tests i simulacres mensuals per arribar preparat al 100%",
        enabled: false,
        stock: false,
        stock_message: "No disponible.",
        price: 89.99,
        // offer: 89.99,
        // offer_text: "Oferta especial les primeres 10 matrícules!",
        shipment: 0.0,
        images: ["/701/image4"],
        banner: ["/701/image4"],
        link: "/tienda/cursos/curs-online-policia-lcal-sant-boi-2025/",
        created_at: "2025-04-03 00:00:01",
        start_at: "2025-04-03 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 539, group_id: [2226] },
    },
    // Curs Presencial Proves Físiques Policia Local Castelldefels 2025
    {
        id: 702,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Sports],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.proves-fisiques-pol-castelldefels-2025",
        title: "Entrenament Específic Policia Local Castelldefels 2025",
        name: "Entrenament Específic Policia Local Castelldefels 2025",
        description: "Supera les proves físiques amb confiança i seguretat!",
        enabled: false,
        stock: false,
        stock_message: "No disponible temporalment.",
        price: 19.99,
        shipment: 0.0,
        images: ["/702/image1"],
        banner: ["/702/image1"],
        link: "/tienda/cursos/proves-fiisiques-policia-local-castelldefels-2025/",
        created_at: "2025-04-03 00:00:01",
        start_at: "2025-04-03 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        childs: [703, 704],
    },
];
exports.default = products;
